/**
 * @author Trendrating <info@trendrating.net>
 *
 * @module api/_StoredObjects
 * @summary Fixes the wrong server behaviour and provides an unified API to
 *      manage StoredObjects
 *
 * !!! IMPORTANT !!!
 * Classes that inherit _StoredObjects MUST define storedObjectType according to
 * supported server types
 *
 */

import { endpoints } from "./endpoints";
import { _Base } from "./_Base";
import { deepClone } from "./utils/deepClone";
import { StoredObjectType } from "./Api";
export class _StoredObjects extends _Base {
  storedObjectType?: StoredObjectType;
  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  /**
   *
   * @param id The preference object id
   * @param objectType The type of the preference object
   * @param userId ATTENTION this params is used only in the reports hub page to get shared reports templates from the user 35
   *
   * @returns return the found preference object
   */
  async get(id: any, objectType: StoredObjectType, userId: number) {
    let url: string = this.endPointRoot + endpoints.storedObjects.get;

    let params: any = {
      ownerId: userId,
      type: objectType ? objectType : this.storedObjectType,
    };

    if (id != null) {
      url = this.endPointRoot + endpoints.storedObjects.getById;
      params = {
        id: id,
      };
    }

    const response = await this.prepareGet(url, params, null);
    return this._get(response);
  }

  async update(
    object: any,
    objectType: StoredObjectType | null,
    ownerId: number
  ) {
    const url = this.endPointRoot + endpoints.storedObjects.update;

    const _params = deepClone(object);

    // created/modified
    const timestamp = new Date().toISOString();
    _params["created"] = _params["created"] == null ? null : _params["created"]; // managing old without attribute
    _params["modified"] = timestamp;
    _params["ownerId"] = ownerId;
    _params["type"] = objectType ? objectType : this.storedObjectType;

    const result = await this.preparePost(url, _params, null);
    // return this._update(result);
    return result;
  }

  async create(object: any, objectType?: StoredObjectType | null) {
    // const endPointRoot = this.getEndpointRoot(this.environment.api.compute);
    const url = this.endPointRoot + endpoints.storedObjects.create;

    const _params = deepClone(object);
    if ("id" in _params) {
      delete _params.id;
    }

    // created/modified
    const timestamp = new Date().toISOString();
    _params.created = timestamp;
    _params.modified = timestamp;
    // _params.ownerId = this.environment.account.user?.id;
    _params.type = objectType ? objectType : this.storedObjectType;

    const response = await this.preparePost(url, _params, null);
    return this._create(response);
  }

  // -----------------------------------------------------
  // ------------------- private methods
  // -----------------------------------------------------
  _get(response: any) {
    if ("rows" in response.data) {
      return response.data.rows.map((row: any) => this._fix(row));
    } else if ("preference" in response.data) {
      const error = this.simulateHttpError(response);

      if (error != null) {
        return error;
      }

      return this._fix(response.data.preference);
    }

    return [];
  }

  _create(response: any) {
    const error = this.simulateHttpError(response);

    if (error != null) {
      return error;
    }

    return this._fix(response["data"]);
  }

  _fix(storedObject: any) {
    const _storedObject = deepClone(storedObject["object"]);
    _storedObject["id"] = storedObject["id"];
    _storedObject["ownerId"] = storedObject["ownerId"];

    if (storedObject["tags"] != null) {
      _storedObject["tags"] = storedObject["tags"];
    }

    return _storedObject;
  }

  _update(response: any) {
    const error = this.simulateHttpError(response);

    if (error != null) {
      return error;
    }

    return this._fix(response["data"]);
  }
}
